import { ApiCallMetrics } from "../../../../core/internal/metrics/monitoring/MonitoringMetricRegistry"
import { TimerSample } from "../../../../core/internal/metrics/Timer"
import { Transport, TransportRequest, TransportResponse } from "../../../../core/internal/transport/Transport"

export class InAppMessageHtmlContentFetcher {
  private HTML_REQUEST_TIMEOUT_MILLIS = 5000
  constructor(private readonly transport: Transport) {}

  async fetchHtmlContent(fetchSourcePath: string): Promise<string> {
    const request = this.createRequest(fetchSourcePath)
    const response = await this.execute(request)
    return this.handleResponse(response)
  }

  private createRequest(fetchSourcePath: string): TransportRequest {
    return TransportRequest.builder()
      .url(fetchSourcePath)
      .method("GET")
      .timeoutMillis(this.HTML_REQUEST_TIMEOUT_MILLIS)
      .build()
  }

  private async execute(request: TransportRequest): Promise<TransportResponse> {
    const sample = TimerSample.start()
    try {
      const response = await this.transport.send(request)
      ApiCallMetrics.record("get.iam-html", sample, response)
      return response
    } catch (e) {
      ApiCallMetrics.record("get.iam-html", sample, null)
      throw e
    }
  }

  private handleResponse(response: TransportResponse): string {
    if (!response.isSuccessful()) {
      throw new Error(`Http status code: ${response.statusCode}`)
    }

    if (response.body === null) {
      throw new Error("Response body is null")
    }

    return response.body
  }
}
